import { render, staticRenderFns } from "./SmallLicenseCard.vue?vue&type=template&id=0e55d36d&scoped=true&lang=pug"
import script from "./SmallLicenseCard.vue?vue&type=script&lang=js"
export * from "./SmallLicenseCard.vue?vue&type=script&lang=js"
import style0 from "./SmallLicenseCard.vue?vue&type=style&index=0&id=0e55d36d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e55d36d",
  null
  
)

export default component.exports